import type { FieldValues } from "react-hook-form";
import { FormComponent } from "../FormComponent";
import { FormStateDropdown, type FormStateDropdownProps } from "../fields/FormStateDropdown";
import type { FormComponentProps } from "../types";

export type FormStateDropdownComponentProps<TFieldValues extends FieldValues> =
	FormComponentProps<TFieldValues> &
		Omit<FormStateDropdownProps<TFieldValues>, "control" | "name"> & {
			name: FormComponentProps<TFieldValues>["name"];
		};

export const FormStateDropdownComponent = <TFieldValues extends FieldValues>(
	props: FormStateDropdownComponentProps<TFieldValues>,
) => {
	const { formMethods, ...restProps } = props;
	const { control } = formMethods;
	return (
		<FormComponent {...props}>
			<FormStateDropdown control={control} {...restProps} />
		</FormComponent>
	);
};
